import { ApiSchema } from "@api-types";
import { useObservable } from "@rsm";
import { getFFService } from "services/ff.service";
import { useHasPolicy } from "./useHasPolicy";

export const useHasFF = (ff: ApiSchema.FF) => {
  return useObservable(getFFService().featureEnabled$(ff));
};

export const useHasReskinFF = () => {
  const hasFf = useObservable(getFFService().featureEnabled$("Reskin"));
  const isSuper = useHasPolicy("IdeallyResearch");
  return !!hasFf || !!isSuper;
};

export const useHasProjectNarrativesFF = () => {
  const hasFf = useObservable(getFFService().featureEnabled$("ProjectNarratives"));
  const isSuper = useHasPolicy("IdeallyResearch");
  return !!hasFf || !!isSuper;
};
